import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import {MerchantService} from "../../../../common/services/merchant.service";
import {MatDialog} from "@angular/material/dialog";
import {Merchant} from "../../../../common/interfaces/Merchant";
import {WriteReviewDialogComponent} from "./write-review-dialog/write-review-dialog.component";
import {Rating, RatingApiResponse} from "../../../../common/interfaces/Rating";
import {BaseApiService} from "../../../../common/services/base-api-service";
import { JWTToken } from "../../../../common/interfaces/JWTToken";
import { RateAPI } from "../../../../common/apis/RateApi";
import { LoginAlertComponent } from "../../../components/login-alert/login-alert.component";
import { AuthService } from "../../../services/auth.service";

@Component({
  selector: 'app-merchant-review-tab',
  templateUrl: './merchant-review-tab.component.html',
  styleUrls: ['./merchant-review-tab.component.scss']
})
export class MerchantReviewTabComponent implements OnInit {



  merchant: Merchant | null
  ratingApiResponse: RatingApiResponse | null
  numberOfReviews = 0
  reviewLabel = $localize`:@@writeReview:Leave a Review`
  customerLoggedIn: boolean = false

   jwtToken : JWTToken  | null = null
   isRemoveRateLoading = false

  @ViewChild(LoginAlertComponent)
  loginAlertComponent?: LoginAlertComponent;

  constructor(
    private merchantService: MerchantService,
    public dialog: MatDialog,
    protected readonly apiClient: BaseApiService,
    protected readonly rateAPI: RateAPI,
    private authService: AuthService

  ) {
  }

  ngOnInit(): void {
    this.merchantService.getMerchantInfo().subscribe({
      next: (merchant) => {
        this.merchant = merchant
      }
    })

    this.merchantService.getRatings().subscribe({
      next: (ratings) => {
        this.ratingApiResponse = ratings
        this.numberOfReviews = ratings!.data.length
      }
    })

    this.jwtToken = this.apiClient.getJwt()

    this.reloadUserLogin()
    this.authService.authChange.subscribe(event => {
      this.reloadUserLogin()
    });
  }

  reloadUserLogin(){
    this.customerLoggedIn = this.authService.geCustomer() != null;
  }



  writeReview() {
    if(this.customerLoggedIn){
      this.dialog.open(WriteReviewDialogComponent, {
        data: {
          id: this.merchant?.id,
          isProduct: false
        },
        width: '37rem',
        autoFocus: false
      }).afterClosed()
        .subscribe({
          next: () => {
            this.merchantService.loadMerchantRatings(this.merchant!.id)}
        });
    }else{

      let errorMessage = $localize`:@@PleaseLoginToLeaveReview:Please login to leave a review`
      this.loginAlertComponent?.showScreen({warningMessage:errorMessage});
      this.loginAlertComponent?.onSuccess.subscribe(() => {
        // Triggering change detection to update the view
        this.writeReview()
      })
    }

  }

  hasReviews(): boolean {
    if (this.ratingApiResponse === null || this.ratingApiResponse === undefined) {
      return false;
    } else return this.ratingApiResponse?.data.length > 0;
  }

  getAverageRating(): string {
    let totalRating = 0
    for (let rating of this.ratingApiResponse!.data) {
      totalRating += rating.rating
    }
    return (totalRating / this.numberOfReviews).toFixed(2)
  }

  showRemoveBtn(rating : Rating):boolean {
   return  rating.commenter.id === this.jwtToken?.customer?.id
  }

  onRemoveRate(rate : Rating) {
    this.isRemoveRateLoading = true
    this.rateAPI.deleteRate({ rate: rate }).subscribe({
      next: () => {
        this.merchantService.loadMerchantRatings(this.merchant!.id)
        this.isRemoveRateLoading = true
      },
      error: (error: any) => {
        this.isRemoveRateLoading = false

      },
    });
  }

  getImageAvatar(rate:Rating):string{
   let image =  "assets/customer-icon-placeholder.svg"
    let profilePictureURL = rate.commenter.profilePictureURL ?? ""
    if(profilePictureURL.hasActualValue()){
      image = profilePictureURL
    }
    return image
  }
}
